import { UseMutationResult, useMutation } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IUnfreezeUserResponse {
  token: string;
}

export interface IUnfreezeUserParams {
  accepted_agreement_ids: Array<string>;
}

export interface IUseUnfreezeUserProps {
  onSuccess?: (data: IUnfreezeUserResponse) => void;
  onError?: () => void;
}

export default function useUnfreezeUser(
  props?: IUseUnfreezeUserProps
): UseMutationResult<IUnfreezeUserResponse, unknown, IUnfreezeUserParams> {
  const axios = useAxios();

  const unfreezeUser = async (params: IUnfreezeUserParams) => {
    const response = await axios
      .put(`/v1/users/0/unfreeze`, {
        accepted_agreement_ids: params.accepted_agreement_ids,
      })
      .then((r) => r.data as IUnfreezeUserResponse);
    return response;
  };

  const mutation = useMutation(unfreezeUser, {
    onError: props?.onError,
    onSuccess: props?.onSuccess,
  });

  return mutation;
}
